import { axios } from '@/utils/request'

export function login(parameter){
    return axios({
        url:'v2/UserLogin',
        method:'post',
        data:parameter
    })
}

export function getPhoneCode(parameter){
    return axios({
        url:'v2/SendCode',
        method:'post',
        data:parameter
    })
}

export function getUserInfo(parameter){
    return axios({
        url:'v2/validate/UserInfo',
        method:'post',
        data:parameter
    })
}

export function signUpData(parameter){
    return axios({
        url:'/v2/Register',
        method:'post',
        data:parameter
    })
}